
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HorizontalStepperLabelStep extends Vue {
  @Prop({ type: String, required: true }) readonly number!: string;
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: Boolean, default: false }) readonly notification!: boolean;
  @Prop({ type: Boolean, default: false }) readonly active!: boolean;

  get classes() {
    const { active, notification } = this;
    return {
      "horizontal-stepper-label-step_active": active,
      "horizontal-stepper-label-step_notification": notification,
    };
  }
}
